export default __webpack_public_path__ + "static/media/c1.c397c29f.jpeg";